import '@/styles/livePlay.scss';
import React, { useState, useEffect, Fragment } from 'react';
import Player from 'aliplayer-react';
import { Icon, Toast, NavBar, Tabs } from 'antd-mobile';
import {
  getUser,
  getPlatConfig,
  getBooleanValue,
  getDefaultCover,
} from '@/utils/index';
import { liveInfo as getLive } from '@/services/tscloud/active';
import Openfire from '@/components/openfire';

function LivePlay(props) {
  const [tabList] = useState([
    { title: '课程详情', key: 'detail' },
    { title: '互动交流', key: 'chat' },
  ]);
  const { teacher: teacherCover } = getDefaultCover();
  const [ins, setIns] = useState();
  const [config, setConfig] = useState({
    source: '',
    width: '100%',
    height: '100%',
    autoplay: false,
    isLive: true,
    rePlay: false,
    playsinline: true,
    preload: true,
    controlBarVisibility: 'hover',
    useH5Prism: true,
  });
  const [liveInfo, setInfo] = useState({
    title: '',
    teacher: '',
    desc: '',
  });

  const [errorInfo, setErrorInfo] = useState({
    error: false,
    errorText: '',
  });

  const { reqIp } = getPlatConfig() || {};

  const {
    match: {
      params: { id },
    },
  } = props;

  const getLiveInfo = async function () {
    const { userId } = getUser();
    try {
      const resp = await getLive({
        id,
        reqIp,
        isPc: 'no',
        userId,
      });
      if (resp.success === 'true' && resp.data) {
        const { activityName, createUserName, remark, liveUrl } = resp.data;
        setInfo({
          title: activityName,
          teacher: createUserName,
          desc: remark,
        });
        config.source = liveUrl;
        setConfig(config);
      } else {
        Toast.info(resp.retDesc || resp.message);
        setErrorInfo({
          error: true,
          errorText: resp.retDesc || resp.message,
        });
      }
    } catch (err) {
      Toast.info(err);
      setErrorInfo({
        error: true,
        errorText: err,
      });
    }
  };

  useEffect(() => {
    if (ins) {
      const play = () => {
        ins.play();
      };
      ins.on('canplay', play);
      return () => {
        ins.off('canplay', play);
      };
    }
  });

  useEffect(() => {
    getLiveInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`livePlay ${getBooleanValue('IS_IMMERSE', false) ? 'immerse' : ''}`}>
      <NavBar
        mode="light"
        icon={<Icon type="left" style={{ color: '#fff' }} />}
        onLeftClick={() => window.history.go(-1)}
      >
        <span>{liveInfo.title}</span>
      </NavBar>
      <div className="player">
        {errorInfo.error ? (
          <div className="errorText">{errorInfo.errorText}</div>
        ) : (
          config.source && (
            <Player
              config={config}
              onGetInstance={(instance) => {
                setIns(instance);
              }}
            />
          )
        )}
      </div>
      <div className="livePlay-info">
        <Tabs
          tabs={tabList}
          tabBarPosition="top"
          tabBarUnderlineStyle={{
            width: `11.867vw`,
            height: '0.667vw',
            backgroundColor: '#4590fc',
            borderRadius: '0.332vw',
            marginLeft: '19vw',
          }}
          animated={false}
          swipeable={false}
          useOnPan={false}
        >
          <Fragment key="detail">
            <div className="detail">
              <div className="post">
                <img src={teacherCover} alt="" />
              </div>
              <div>
                <div className="teacher">{liveInfo.teacher}</div>
                {/* <div className="dept">{liveInfo.deptName}</div> */}
                <div className="tags">
                  {/* {
                    liveInfo.attr ?
                      liveInfo.attr.map((item, index) => (
                        <Tag small key={item.attributeId} style={{ margin: '3px' }} color="blue">
                          {item.attributeValueName}
                        </Tag>
                      )) : null
                  } */}
                </div>
              </div>
              <div className="desc">课程简介：</div>
              <div className="intro">{liveInfo.desc}</div>
            </div>
          </Fragment>
          <Fragment key="chat">
            <div style={{ height: '100%' }}>
              <Openfire groupId={id} />
            </div>
          </Fragment>
        </Tabs>
      </div>
    </div>
  );
}

export default LivePlay;
